import { useFela } from 'react-fela';

import { Text } from '@/modules/ui';

import type { WhitelistUser } from '../../types';
import * as felaRules from '../Whitelist/Whitelist.rules';
import { WhitelistItem, type WhitelistItemProps } from '../WhitelistItem';

export interface FormFieldWhitelistProps extends Pick<WhitelistItemProps, 'onRemove' | 'onUpdate' | 'hasPasskey' | 'roles'> {
    value: WhitelistUser[];
}

export const FormFieldWhitelist = ({ value, onRemove, onUpdate, hasPasskey, roles }: FormFieldWhitelistProps) => {
    const { css } = useFela({
        removable: true,
    });

    if (!value.length) {
        return null;
    }

    return (
        <div className={css(felaRules.container)}>
            <Text variant='ParagraphSmallMedium' elementType='ul' customStyle={felaRules.list}>
                {value.map(item => (
                    <WhitelistItem
                        key={item.id}
                        {...item}
                        editable
                        onRemove={onRemove}
                        onUpdate={onUpdate}
                        hasPasskey={hasPasskey}
                        roles={roles}
                    />
                ))}
            </Text>
        </div>
    );
};
